import { getVideoProjectEventForStatusChange, VideoProjectStatusColumnId } from "@/components/VideoProjectStatusPicker";
import { VideoProject } from "@/services/bedrock";

const SUBMIT_EVENTS = new Set<VideoProject.Event>([
  VideoProject.Event.SUBMIT_FOR_QA_REVIEW,
  VideoProject.Event.COMPLETE,
]);

const QA_REVIEW_EVENTS = new Set<VideoProject.Event>([
  VideoProject.Event.START_QA_REVIEW,
  VideoProject.Event.APPROVE_QA,
  VideoProject.Event.REJECT_QA,
]);

export type EditorStatusColumnAction =
  | { type: "submit"; event: VideoProject.Event.SUBMIT_FOR_QA_REVIEW | VideoProject.Event.COMPLETE }
  | { type: "qa_review" }
  | { type: "status_event"; event: VideoProject.Event; userId?: number };

export function resolveEditorStatusColumnAction(
  status: VideoProject.Status,
  columnId: VideoProjectStatusColumnId,
  options?: { requiresQa?: boolean | null; currentUserId?: number }
): EditorStatusColumnAction | null {
  const request = getVideoProjectEventForStatusChange(status, columnId, options);
  if (!request) return null;

  if (SUBMIT_EVENTS.has(request.event)) {
    return {
      type: "submit",
      event: request.event as VideoProject.Event.SUBMIT_FOR_QA_REVIEW | VideoProject.Event.COMPLETE,
    };
  }

  if (QA_REVIEW_EVENTS.has(request.event)) {
    return { type: "qa_review" };
  }

  return { type: "status_event", event: request.event, userId: request.userId };
}
